import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit, Input, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
// Animations
import { slideInDownAnimation } from '../../app/app.animation';
// Common
import { AngularMaterialService, ErrorParseService, IAdmin, IUser, PermissionsService, LGEDataService } from '../../commons';
// State
import { Store } from '@ngrx/store';
import * as fromAdmin from './state/admin.selectors';
import * as fromAuth from '../login/state/login.selectors';
import * as AdminAction from './state/admin.actions';
import * as lgeApp from '../../app/state/app.actions';
import { environment } from '../../environments/environment';
import { Observable, skipWhile } from 'rxjs';
import { Subscription } from 'rxjs';
import { MatStepper } from '@angular/material/stepper';
// import * as app from '../../app/state/app.actions';

@Component({
    selector: 'admin-screen',
    templateUrl: 'admin.component.html',
    styleUrls: ['admin.scss'],
    animations: [slideInDownAnimation],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AdminScreenComponent implements OnInit, OnDestroy {
    @Input() private pending$: Observable<boolean>;
    private pendingSubscription: Subscription;
    private pending: boolean;
    @Input() private error$: Observable<string | null>;
    private errorSubscription: Subscription;
    private error: string | null;
    @Input() private stateData$: Observable<IAdmin | null>;
    private stateDataSubscription: Subscription;
    private stateData: IAdmin | null;
    @Input() private userDetails$: Observable<IUser>;
    private userDetailsSubscription: Subscription;
    private userDetails: IUser | null;
    @ViewChild('stepper') stepper: MatStepper;

    isAdmin = 'ADMIN';

    selectedReport = '';
    reports = [{ name: 'CC Applications', value: 'CC Applications' },
    { name: 'CC Approvals Audit Logs', value: 'CC Approvals Audit Logs' },
    { name: 'Credit Card Payments', value: 'Credit Card Payments (All Grants)' },
    { name: 'Community Grants', value: 'External Grants/Community Grants' },
    { name: 'PFTP Grants', value: 'External Grants/PFTP Grants' },
    { name: 'Event Sponsorship', value: 'External Grants/Event Sponsorship Grants' },
    { name: 'External User Profiles', value: 'External Grants/External User Profiles' },
    { name: 'All Contributions', value: 'Charitable Contributions - All Contributions' }];

    employeeData: any = []
    employeeInfo: FormGroup;

    constructor(
        private store: Store<fromAdmin.State>,
        private ref: ChangeDetectorRef,
        private fb: FormBuilder,
        private ams: AngularMaterialService,
        private errorParse: ErrorParseService,
        private permissionsService: PermissionsService,
        private route: ActivatedRoute,
        private router: Router,
        private _dataService: LGEDataService
    ) {
        this.selectState();
        this.createForms();
    }


    ngOnInit() {
        this.startSubscriptions();
    }

    NotifyApprovarForOutstandingTask() {
        this.ams.showLoader('Sending...');
        this._dataService.NotifyApprovarForOutstandingTask().subscribe(
            {
                next: data => {
                    this.ams.closeDialog();
                    this.ams.showAlert('Success!', 'Successfully Sent!');
                    this.ref.markForCheck();
                },
                error: error => {
                    this.ams.closeDialog();
                    this.ams.showAlert('Error!', `Please try again later! \n Details:${JSON.stringify(error)}`);
                    this.ref.markForCheck();
                }
            }
        )
    }

    onOpenReport() {
        // let serverURL = 'https://msbirpt600/MSBITestReports/powerbi/User%20Defined%20Testing/Andy%20Tran/CCMS/';
        // if (environment.MVC_URL.includes('produi')) {
        //     serverURL = 'https://msbirpt100/MSBIReports/powerbi/Corporate%20Responsibility%20and%20Community%20Affairs/User%20Defined%20Reports/'
        // }

        // 06/29/2020 MV PowerBI Upgrade. Both Test and Prod rpt server have been upgraded with new URL
        // https://msbirpt600/MSBITestReports => https://msbirpttest/reports
        // https://msbirpt100/MSBIReports => https://msbirptprod.lgeenergy.int/reports

        let serverURL = 'https://msbirpttest/reports/powerbi/User%20Defined%20Testing/Andy%20Tran/CCMS/';
        if (environment.MVC_URL.includes('produi')) {
            serverURL = 'https://msbirptprod.lgeenergy.int/reports/powerbi/Corporate%20Responsibility%20and%20Community%20Affairs/User%20Defined%20Reports/'
        }
        let biRptUrl = `${serverURL}${this.selectedReport}?rs:Command=Render&rc:Toolbar=false`
        window.open(biRptUrl, '_blank');
    }

    ResetApprovarForOutstandingTask() {
        this.ams.showLoader('Resetting...');
        this._dataService.ResetApprovarForOutstandingTask().subscribe({
            next: data => {
                this.ams.closeDialog();
                this.ams.showAlert('Success!', 'Successfully Reset!');
                // console.log('ResetOutstandingTask :', data);
                this.ref.markForCheck();
            },
            error: error => {
                this.ams.closeDialog();
                this.ams.showAlert('Error!', `Please try again later! \n Details:${JSON.stringify(error)}`);
                // console.log('ResetOutstandingTask: ', error);
                this.ref.markForCheck();
            }
        })
    }

    GetDOAForApprover() {
        this.ams.showLoader('Sending...');
        this._dataService.GetDOAForApprover().subscribe({
            next: data => {
                this.ams.closeDialog();
                this.ams.showAlert('Success!', 'Successfully Sent!');
                // console.log('GET_DOA_AND_NOTIFY_ADMIN :', data);
                this.ref.markForCheck();
            },
            error: error => {
                this.ams.closeDialog();
                this.ams.showAlert('Error!', `Please try again later! \n Details:${JSON.stringify(error)}`);
                // console.log('GET_DOA_AND_NOTIFY_ADMIN: ', error);
                this.ref.markForCheck();
            }
        })
    }

    ResetGetDOAForApprover() {
        this.ams.showLoader('Resetting...');
        this._dataService.DeleteAllApproverDOALog().subscribe({
            next: data => {
                this.ams.closeDialog();
                this.ams.showAlert('Success!', 'Successfully Reset!');
                this.ref.markForCheck();
            },
            error: error => {
                this.ams.closeDialog();
                this.ams.showAlert('Error!', `Please try again later! \n Details:${JSON.stringify(error)}`);
                this.ref.markForCheck();
            }
        })
    }

    onSubmit() {
        this.ams.showLoader('Loading...');
        // console.log(this.employeeInfo.value)
        this._dataService.GetEmployeeHierarchyTest(this.employeeInfo.get('EmpId').value).subscribe({
            next: data => {
                // console.log('Employee Info');
                // console.log(data);
                this.employeeData = data;
                this.ref.markForCheck();
                if (this.stepper)
                    this.stepper.selectedIndex = 0;
                this.ams.closeDialog();
                this.ref.markForCheck();
            }, error: error => {
                // console.log(error);
                if (error.message.includes("Invalid Employee ID"))
                    this.ams.showAlert('Invalid Employee ID!', '');
                else {
                    this.ams.closeDialog();
                    this.ams.showAlert('Error!', `Please try again later! \n Details:${JSON.stringify(error)}`);
                }
            }
        })
    }

    onUpdateSubsection() {
        this.ams.showLoader('Updating 501 Subsection ...');
        this._dataService.GetSubsection().subscribe(
            {
                next: () => {
                    this.ams.closeDialog();
                    this.ref.markForCheck();
                },
                error: error => {
                    this.ams.closeDialog();
                    if (!error.message.includes('Timeout')) {
                        this.ams.showAlert('Warning', `Failed to update Subsections ${error.message}`);
                    }
                    this.ref.markForCheck();
                }
            }
        )
    }

    onStepChange(event, step) {
        step.selected.interacted = false;
    }
    // Create reactive forms
    createForms(): void {
        this.employeeInfo = this.fb.group({
            // 'EmpId': ['']
            'EmpId': ['', Validators.pattern(new RegExp(/^[enEN][0-9]{6}$/))]
        });

    }

    // Select state
    selectState(): void {
        this.userDetails$ = this.store.select(fromAuth.getUser);
        this.pending$ = this.store.select(fromAdmin.getAdminScreenPending);
        this.stateData$ = this.store.select(fromAdmin.getAdminState);
        this.error$ = this.store.select(fromAdmin.getAdminScreenError).pipe(skipWhile(error => error === undefined || error === null || error === ''));
    }

    displayLoader(pending: boolean): void {
        if (pending) {
            this.ams.showLoader("Loading");
        } else {
            this.ams.closeDialog().then(() => {
                if (this.error !== null && this.error !== undefined && this.error !== '') {
                    this.displayError(this.error);
                }
            });
        }
    }

    displayError(error: any): void {
        let errorMessage;
        if (this.errorParse.foundKeyWord(error, "CORPCOMMONWS")) {
            errorMessage = this.errorParse.translateCCError(error);
        } else {
            errorMessage = error instanceof Object ? error.message : error;
        }
        this.ams.showAlert("Loading Error", errorMessage);
        this.ams.alert.afterClosed().subscribe(result => {
            this.store.dispatch(new AdminAction.AdminScreenErrorReset());
        });
    }


    // Opens sidenav if on mobile
    public openSidenav(): void {
        this.store.dispatch(new lgeApp.OpenSidenav());
    }
    // Subscribe to state data and mark it for changes
    startSubscriptions(): void {
        this.pendingSubscription = this.pending$
            .subscribe(data => {
                this.pending = data;
                this.displayLoader(this.pending);
                this.ref.markForCheck();
            });
        this.errorSubscription = this.error$
            .subscribe(data => {
                this.error = data;
                this.ref.markForCheck();
            });
        this.stateDataSubscription = this.stateData$
            .subscribe(data => {
                this.stateData = data;
                this.ref.markForCheck();
            });
        this.userDetailsSubscription = this.userDetails$
            .subscribe(data => {
                this.userDetails = data;
                // this.isAdmin = this.permissionsService.hasRoles('ADMIN');
                this.ref.markForCheck();
            });
    }

    hasRole(role: string) {
        return this.permissionsService.hasRoles(role);
    }

    // Unsubscribe from state data changes
    private endSubscriptions(): void {
        this.pendingSubscription.unsubscribe();
        this.errorSubscription.unsubscribe();
        this.stateDataSubscription.unsubscribe();
    }

    // overrideReportingHeirarchy() {
    //     this.router.navigate([`admin/override-reporting-heirarchy`]);
    // }

    ngOnDestroy() {
        this.endSubscriptions();
    }


}